/**
 * SheenOverlay: the cut's hover sheen for an image-backed card.
 *
 * The engine's .sheen-hover draws --sheen on the host's ::before at
 * z-index -1, which lands above the host background and below its content.
 * On a card whose photo is a full-bleed `absolute inset-0 z-0` wrapper, the
 * photo paints over that layer, so the sheen never reached the screen (a
 * hover probe measured a 0.00% pixel change between the black and fire
 * cuts on the home featured post). On 2026-10-01 fire was renamed rainbow.
 * Since the overlay hybrid of the same day, rainbow carries a sheen in both
 * schemes (a pastel stripe in light, prism rims and a band in dark), red,
 * blue and green carry an edge light in dark only, and black carries none,
 * so this overlay reveals whatever the cut and scheme carry and paints
 * nothing where --sheen is none.
 *
 * This overlay is a sibling placed after the image wrapper and before the
 * card content (z-10): it carries .sheen-hover itself, so its ::before
 * paints above the photo and below the text. It never takes pointer events,
 * so it cannot hover on its own; the reveal is keyed to the card's `group`
 * instead (hover, focus-visible, focus-within, the same three states the
 * engine reveals on). The revealed opacity matches the engine's 0.2.
 *
 * Forced colors and reduced motion are inherited from the engine: the layer
 * is dropped under forced-colors, and the reveal is instant under reduced
 * motion. A host that renders this overlay must carry `group` and
 * `relative`, and should drop .sheen-hover from itself, since its own layer
 * would sit hidden under the photo.
 */
export function SheenOverlay() {
  return (
    <div
      aria-hidden="true"
      data-sheen-overlay=""
      className="sheen-hover pointer-events-none absolute inset-0 z-5 group-hover:before:opacity-20 group-focus-visible:before:opacity-20 group-focus-within:before:opacity-20"
    />
  );
}
